var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {
        'sw-text': true
    }, _obj[_vm.$style['name']] = true, _obj[_vm.$style['name_inverted']] = _vm.inverted, _obj )},[_vm._v("\n    "+_vm._s(_vm.title)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }